<wdx-icon-button
    [class.has-issue]="hasIssue"
    [size]="size"
    [overflowVisible]="count > 0 ? true : false"
    [positionRelative]="count > 0 ? true : false"
    [attr.data-cy]="cySelector"
    [disabled]="disabled ? true : null"
    (wdxOnClick)="onClick($event)"
>
    @if (count > 0) {
        <wdx-icon
            [icon]="hasIssue ? ICON_COMMENT_ISSUE : ICON_COMMENT"
        ></wdx-icon>
        <wdx-badge class="count">
            {{ count }}
        </wdx-badge>
    } @else {
        <wdx-icon icon="comment-plus"> </wdx-icon>
    }
</wdx-icon-button>
